
/* injects from baggage-loader */

'use strict';

export default function (app) {
	app.service('Projects', function (Parse, ProjectSchema) {

		// ==================================================
		// Load object schema
		// ==================================================
		// let Project = Parse.Object.extend('Projects');
		let Project = ProjectSchema;


		// ==================================================
		// Methods
		// ==================================================

		/**
		 * Retrieve the list of projects
		 */
		this.list = () => {
			let query = new Parse.Query(Project);
			query.include('main_media');
			return query.find();
		};

		/**
		 * Returns the count of all visible projects
		 */
		this.count = () => {
			let query = new Parse.Query(Project);
			return query.count();
		}

		/**
		 * Retrieve a project by ID
		 */
		this.get = (id, options = {}) => {
			let query = new Parse.Query(Project);
			query.include('main_media');
			if (typeof options.include !== 'undefined') {
				query.include(options.include);
			}
			return query.get(id);
		}

	});
}




// WEBPACK FOOTER //
// ./src/app/core/services/projects.service.js